import SharedSupportTicket from "../default/components/SupportTicket";

const SupportTicket = (props) => {
    return <SharedSupportTicket variant="it-support" {...props} />;
};

export default SupportTicket;